import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

function initProductFilterController() {
    const state = {
        category: ''
    };

    const overlay = document.querySelector('.product__filter-overlay');
    const sheet = document.querySelector('.product__filter-sheet');
    const trigger = document.querySelector('.product__filter-mobile-trigger');
    const closeBtn = document.querySelector('.product__filter-close');
    const applyBtn = document.querySelector('.product__filter-apply');
    const resetBtn = document.querySelector('.product__filter-reset-mobile');

    function open() {
        overlay.classList.add('active');
        sheet.classList.add('active');
        document.body.style.overflow = 'hidden';
    }

    function close() {
        overlay.classList.remove('active');
        sheet.classList.remove('active');
        document.body.style.overflow = '';
    }

    function selectCategory(btn) {
        document.querySelectorAll('.product__category-mobile')
            .forEach(b => b.classList.remove('active'));

        btn.classList.add('active');
        state.category = btn.dataset.value;
    }

    function apply() {

        const text = document.querySelector('.product__category-mobile.active').innerText;

        // sync desktop label
        document.getElementById('selected-category').innerText = text;
        document.getElementById('selected-category-mobile').innerText = text;

        loadProducts(1, state.category); // reuse existing AJAX
        close();
    }

    function reset() {
        state.category = '';

        // Sync mobile buttons
        document.querySelectorAll('.product__category-mobile')
            .forEach(b => b.classList.remove('active'));
        const allBtn = document.querySelector('.product__category-mobile[data-value=""]');
        if (allBtn) allBtn.classList.add('active');

        // Sync desktop buttons & labels
        document.querySelectorAll('.product__category, .product__category-mobile')
            .forEach(b => b.classList.remove('active'));
        document.querySelectorAll('[data-value=""]')
            .forEach(b => b.classList.add('active'));

        const defaultLabel = 'All Product';
        const desktopLabel = document.getElementById('selected-category');
        const mobileLabel  = document.getElementById('selected-category-mobile');
        if (desktopLabel) desktopLabel.innerText = defaultLabel;
        if (mobileLabel)  mobileLabel.innerText  = defaultLabel;

        // Close sheet first, then trigger load
        close();

        // Sync jQuery-land state and reload
        // Trigger a click on the desktop "All" category button to reuse existing flow
        const allDesktop = document.querySelector('.product__category[data-value=""]');
        if (allDesktop) {
            allDesktop.click();
        }
    }

    function bindEvents() {

        if (!trigger) return;

        trigger.addEventListener('click', open);
        overlay.addEventListener('click', close);
        closeBtn.addEventListener('click', close);
        applyBtn.addEventListener('click', apply);
        resetBtn.addEventListener('click', reset);

        document.querySelectorAll('.product__category-mobile')
            .forEach(btn => {
                btn.addEventListener('click', () => selectCategory(btn));
            });
    }

    bindEvents();
}

function initModalSwiper() {
    const swiper = new Swiper('.swiper--modal', {
        modules: [Navigation],
        navigation: {
            nextEl: '.swiper__next',
            prevEl: '.swiper__prev',
        },
    });
    return swiper;
}

// Export globally so product-ajax.js can use it
window.initModalSwiper = initModalSwiper;

document.addEventListener('DOMContentLoaded', () => {
    initProductFilterController();
});
